import type { WiwState } from '@/store';

export const requestTypes = (state: WiwState) => state.data.requestTypes.items;

export const requestTypesReady = (state: WiwState): boolean => state.data.requestTypes.loaded;

export const requestTypesUpdating = (state: WiwState): boolean => {
  return state.data.requestTypes.loaded && state.data.requestTypes.loading;
};
